import { commonKeywords } from "./common";

const pl = {
    seo: {
        title: "xsiadron - Łukasz Frydrych | Twórca gier, aplikacji i stron",
        description:
            "xsiadron.pl to portfolio Łukasza Frydrych, działającego pod pseudonimem xsiadron, z projektami gier indie, aplikacji, stron internetowych, narzędzi i kreatywnego software'u.",
        siteName: "xsiadron.pl",
        locale: "pl_PL",
        language: "pl",
        keywords: [
            ...commonKeywords,
            "twórca gier indie",
            "programista aplikacji",
            "web developer",
            "programista React",
            "programista Next.js",
            "programista z Polski",
        ],
    },
    nav: {
        about: "O&nbsp;mnie",
        projects: "Projekty",
        socials: "Sociale",
        home: "Strona główna",
        privacy: "Polityka prywatności",
        languageLabel: "Język",
    },
    about: {
        fullname: "Łukasz Frydrych",
        rolePrefix: "Indie",
        roleGame: "game",
        roleApp: "app",
        roleWeb: "web",
        roleSuffix: "developer",
        greeting: "Hej!",
        intro: "Jestem kreatywnym programistą z Polski, który zamienia pomysły w nowoczesne rozwiązania cyfrowe.",
        introSecond: "Tworzę projekty z dbałością o jakość, estetykę i każdy detal.",
        builtPrefix: "Moje projekty powstają w",
        tools: {
            game: "Unreal Engine",
            android: "Android Studio",
            graphics2d: "Programach do grafiki 2D",
            graphics3d: "Programach do grafiki 3D",
            media: "Programach do montażu audio/video",
            various: "& różnych",
            ides: "IDE",
        },
        languagesPrefix: "Programuję w",
        contact: "Chcesz stworzyć coś wyjątkowego?",
        contactLink: "Skontaktuj się ze mną!",
    },
    skills: {
        heading: "Umiejętności",
        items: {
            "Game Development": {
                name: "Tworzenie gier",
                description: "Tworzenie interaktywnych gier i doświadczeń w różnych silnikach oraz frameworkach",
            },
            "Web Development": {
                name: "Strony interntetowe",
                description: "Full-stack web development w nowoczesnych technologiach, takich jak React, Next.js i Node.js",
            },
            "App Development": {
                name: "Tworzenie aplikacji",
                description: "Budowanie aplikacji mobilnych i desktopowych z intuicyjnymi interfejsami",
            },
            Scripting: {
                name: "Skrypty",
                description: "Automatyzacja, przetwarzanie danych i tworzenie narzędzi w różnych językach skryptowych",
            },
            "3D Modeling": {
                name: "Modelowanie 3D",
                description: "Tworzenie modeli 3D, animacji i interaktywnych doświadczeń 3D",
            },
            Illustration: {
                name: "Ilustracja",
                description: "Digital art, projektowanie UI/UX i tworzenie treści wizualnych",
            },
        },
    },
    projects: {
        heading: "Projekty",
        noResults: "Żaden projekt nie pasuje do wybranych filtrów.",
        moreDetails: "Więcej",
        openProject: "Otwórz {{title}}",
        moreAbout: "Więcej o {{title}}",
        filter: {
            searchProjects: "Szukaj projektów...",
            searchTags: "Szukaj tagów...",
            switchToTag: "Przełącz na wyszukiwanie tagów",
            switchToProject: "Przełącz na wyszukiwanie projektów",
            tags: "Tagi",
            projects: "Projekty",
            clearAll: "Wyczyść",
            clearAllTitle: "Wyczyść wszystkie filtry",
            removeTag: "Kliknij, aby usunąć",
        },
        categories: {
            "Project Types": "Typy projektów",
            "Programming Languages": "Języki programowania",
            "Tools & Platforms": "Narzędzia i platformy",
        },
        tags: {
            Game: "Gry",
            Web: "Web",
            App: "Aplikacje",
            Script: "Skrypty",
            "3D": "3D",
            "2D": "2D",
            Videos: "Video",
            Android: "Android",
            Software: "Software",
            Editor: "Edytor",
            Mobile: "Mobile",
            Polish: "Polski",
            Productivity: "Produktywność",
            "Chrome Extension": "Rozszerzenie Chrome",
        },
        items: {
            "librus-statistics": {
                date: "Czerwiec 2023",
                description:
                    '<b>Librus Statistics</b> to aplikacja webowa stworzona w React. Jest przeznaczona dla użytkowników w Polsce i pozwala wygodnie korzystać z informacji dostępnych w: <a style="color: #608fbf; font-weight: bold;" href="https://portal.librus.pl/rodzina" target="_blank" rel="noopener noreferrer">portal.librus.pl/rodzina</a>.<br/><br/>Zawiera informacje o koncie użytkownika, przedmiotach, frekwencji oraz ocenach z bieżącego roku.',
            },
            litecode: {
                date: "Styczeń 2026",
                description:
                    '<b>LiteCode</b> to nowoczesna przestrzeń robocza do tworzenia <span style="background:linear-gradient(90deg,#0aa1ff,#8f69ff,#ff4aa9); -webkit-background-clip:text; background-clip:text; color:transparent; opacity: 0.5; filter: invert(1) hue-rotate(180deg); blur(12px) saturate(120%); mix-blend-mode: difference;">ekspresyjnych</span> i <span>dopracowanych</span> fragmentów kodu lub tekstu.<br><br><span style="color:#94a3b8">-</span> Przesuwaj i przybliżaj siatkę<br><span style="color:#94a3b8">-</span> Swobodnie ustawiaj motyw i ułożenie<br><span style="color:#94a3b8">-</span> Zmieniaj rozmiar, wyrównuj i dopracowuj detale<br><span style="color:#94a3b8">-</span> Personalizuj tło, padding i zaokrąglenia<br><span style="color:#94a3b8">-</span> Kopiuj, eksportuj i zapisuj od razu<br><br><span style="background:linear-gradient(90deg,#facc15,#f97316); -webkit-background-clip:text; background-clip:text; color:transparent;">Stworzone dla developerów.</span> <span style="color:#64748b">Zaprojektowane dla każdego.</span>',
            },
            veamly: {
                date: "Luty 2023",
                description:
                    '<b>Veamly</b> to natywna aplikacja na Androida, która pozwala zapisywać własne znaczenia słów lub ich tłumaczenia.<br /><br /><span style="color: #608fbf; font-weight: bold;">Aplikacja ułatwia zapamiętywanie i naukę</span>, a jednocześnie może działać jak prosty <b>notatnik</b>.<br /><br />Po instalacji znajdziesz w niej między innymi:<ul><li><b>Własne słowniki</b></li><li><b>Zaawansowane testy zapamiętywania</b></li><li><b>Fiszki do nauki nowego słownictwa</b></li></ul>Miłej nauki z <b>Veamly</b>.',
            },
            "youtube-music-manager": {
                date: "Lipiec 2024",
                description:
                    "<strong>YouTube Music Manager</strong> to praktyczne rozszerzenie do YouTube Music.<br />Dodaje precyzyjne <b>procenty głośności</b> do suwaka i poprawia jego <b>responsywność</b>.<br /><br /><strong>Wbudowany Auto-Pause Manager</strong> zatrzymuje muzykę, gdy odtwarzasz film, a potem <i>automatycznie ją wznawia</i>, kiedy film się kończy, dzięki czemu multitasking jest wygodniejszy.",
            },
        },
    },
    socials: {
        heading: "Sociale",
        support: "Wesprzyj mnie :D",
        patreon: "Patreon",
    },
    footer: {
        privacy: "Polityka prywatności",
        copyright: "Copyright © {{year}}. Stworzone przez Łukasza `xsiadron` Frydrych",
    },
    cookies: {
        message:
            "Ta strona używa plików cookies, żeby zapamiętać Twój język i poprawić wygodę korzystania.",
        privacyLink: "Dowiedz się więcej",
        accept: "Rozumiem",
        decline: "Odrzuć",
    },
    privacy: {
        title: "Polityka prywatności",
        seoTitle: "Polityka prywatności | xsiadron.pl",
        seoDescription: "Polityka prywatności treści cyfrowych, gier, aplikacji i stron tworzonych przez xsiadron.",
        sections: [
            {
                heading: "I. Postanowienia ogólne",
                paragraphs: [
                    "Niniejsza polityka prywatności opisuje, w jaki sposób zbierane, przetwarzane i przechowywane są dane osobowe Użytkowników potrzebne do świadczenia usług związanych ze wszystkimi grami, aplikacjami, stronami internetowymi i innymi treściami cyfrowymi tworzonymi przez xsiadron (Lukasza Frydrycha).",
                    "Serwis zbiera wyłącznie dane osobowe niezbędne do świadczenia i rozwijania oferowanych usług.",
                    "Dane osobowe zbierane za pośrednictwem serwisu są przetwarzane zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych.",
                ],
            },
            {
                heading: "II. Administrator danych",
                paragraphs: [
                    "Administratorem danych osobowych jest xsiadron, a w przypadku aplikacji mobilnych dostępnych w Google Play także Google Play.",
                ],
            },
            {
                heading: "III. Cel zbierania danych osobowych",
                list: [
                    "Komunikacja z Użytkownikiem (formularz kontaktowy itp.).",
                    "Wysyłka newslettera (po wyrażeniu zgody przez Użytkownika).",
                    "Świadczenie usług społecznościowych.",
                    "Promocja oferty Administratora.",
                    "Marketing, remarketing i afiliacja.",
                    "Personalizacja Serwisu dla Użytkowników.",
                    "Zapewnienie optymalnego działania aplikacji i rejestrowanie działań użytkownika.",
                    "Działania analityczne i statystyczne.",
                ],
                paragraphs: [
                    "Podanie danych jest dobrowolne, ale może być niezbędne do zawarcia umowy i korzystania z funkcjonalności Serwisu.",
                ],
            },
            {
                heading: "IV. Udostępnianie danych osobowych",
                paragraphs: [
                    "Dane osobowe Użytkownika mogą być przekazywane, zależnie od funkcjonalności, podmiotom powiązanym z Administratorem, jego podwykonawcom oraz podmiotom współpracującym z Administratorem, np. firmom obsługującym płatności elektroniczne, firmom kurierskim lub pocztowym i kancelariom prawnym.",
                ],
            },
            {
                heading: "V. Prawa Użytkownika",
                list: [
                    "Dostęp do swoich danych osobowych.",
                    "Sprostowanie, usunięcie lub ograniczenie przetwarzania danych.",
                    "Przeniesienie swoich danych.",
                    "Sprzeciw wobec przetwarzania.",
                    "Wycofanie zgody w dowolnym momencie, bez wpływu na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem.",
                ],
                contact: "Użytkownicy mogą zgłaszać żądania dotyczące swoich praw na adres",
            },
            {
                heading: "VI. Pliki cookies i narzędzia analityczne",
                paragraphs: [
                    "Serwis wykorzystuje pliki cookies niezbędne do jego prawidłowego działania, np. do zapamiętania wybranego języka.",
                    "Za zgodą Użytkownika, wyrażoną poprzez baner cookies wyświetlany przy pierwszej wizycie, Serwis korzysta również z następujących narzędzi analitycznych: Google Analytics (dostarczane przez Google LLC) w celu zbierania zanonimizowanych statystyk ruchu na stronie oraz Microsoft Clarity (dostarczane przez Microsoft Corporation) w celu analizy zanonimizowanych zachowań użytkowników (np. kliknięć, przewijania, nagrań sesji) w celu ulepszania Serwisu.",
                    "Te narzędzia analityczne są ładowane w przeglądarce Użytkownika wyłącznie po wyrażeniu zgody i nie są aktywne, jeśli Użytkownik odrzuci zgodę lub jeszcze nie odpowiedział na baner cookies.",
                    "Zgodę można wycofać w dowolnym momencie poprzez wyczyszczenie danych strony (cookies i local storage) dla tej domeny w przeglądarce, co spowoduje ponowne wyświetlenie banera cookies przy kolejnej wizycie.",
                    "Dane przetwarzane przez Google Analytics i Microsoft Clarity podlegają odpowiednim politykom prywatności Google LLC oraz Microsoft Corporation.",
                ],
            },
            {
                heading: "VII. Dane kontaktowe",
                contact: "W sprawach związanych z prywatnością proszę o kontakt mailowy:",
            },
            {
                heading: "VIII. Postanowienia końcowe",
                paragraphs: [
                    "Administrator ma prawo do wprowadzania zmian w Polityce Prywatności, przy czym prawa Użytkowników nie będą ograniczane.",
                ],
            },
        ],
    },
};

export default pl;
